import React, { Fragment, useState, useEffect, useLayoutEffect } from 'react';
import { MoreHorizontal } from 'react-feather';
import Leftbar from './LeftBar';
import AdminBar from './AdminBar';
import Searchbar from './SearchBar';
import { Row } from 'reactstrap';
import { useContext } from 'react';
import CustomizerContext from '../../../_helper/Customizer';

const Header = () => {
    const [sidebartoogle, setSidebartoogle] = useState(true);
    const [searchtoggle, setSearchToggle] = useState(false);

    const { toggleIcon, toggleSidebarResponsive, toggleSidebar } = useContext(CustomizerContext);
    const [toggle, setToggle] = useState(true);

    function useWindowSize() {
        const [size, setSize] = useState([0, 0]);
        useLayoutEffect(() => {
            function updateSize() {
                setSize([window.innerWidth, window.innerHeight]);
                if (window.innerWidth <= 991) {
                    toggleSidebar(true);
                } else {
                    toggleSidebar(false);
                }
            }
            window.addEventListener('resize', updateSize);
            updateSize();
            return () => window.removeEventListener('resize', updateSize);
        }, []);
        return size;
    }
    // eslint-disable-next-line
    const [width] = useWindowSize();

    useEffect(() => {

    }, [toggleSidebar]);

    const toggleResp = (value) => {
        setToggle(value);
        toggleSidebarResponsive(toggle);
        setSearchToggle(!searchtoggle);
    };

    return (
        <Fragment>
            <div className={`page-main-header ${toggleIcon ? 'close_icon' : ''}`}>
                <Row className="main-header-right m-0">
                    <Leftbar sidebartoogle={sidebartoogle} setSidebartoogle={setSidebartoogle} searchistoggled={searchtoggle} />
                    <Searchbar searchtoggle={setSearchToggle} />
                    <AdminBar />
                    <div className="d-lg-none mobile-toggle pull-right w-auto" onClick={() => toggleResp(!toggle)}>
                        <MoreHorizontal />
                    </div>
                </Row>
            </div>

        </Fragment >
    );
};

export default Header;